import Vue from 'vue';

import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  'en': {
    datalevels: 'Data levels',
    providers: 'Providers',
    components: 'Components',
    units: 'Units',
    sensors: 'Sensors',
    mapmenu: 'Map - Observations',
    sensorstatusmenu: 'Map - Status',
    map: 'Map',
    observations: 'Last observations',
    name: 'Name',
    description: 'Description',
    created: 'Created UTC',
    acronym: 'Acronym',
    from: 'From UTC',
    to: 'To UTC',
    component: 'Component',
    components: 'Components',
    value: 'Value',
    unit: 'Unit',
    select: 'Select',
    plotdata: 'Plot data',
    plotdescription1: 'To plot data, double click on the row.',
    plotdescription2: 'To plot multiple sensors, select the lines while pressing Ctrl. Then hit the Plot data button.',
    last24h: 'Last 24 hours',
    olddata: 'Oldest data',
    newdata: 'Most recent data',
    viewtimeseries: 'Date range',
    lastmeasured: 'Last measured',
    datalevel: 'Data level',
    provider: 'Provider',
    sensorregistered: 'Sensor was registered (UTC time)',
    providerregistered: 'Provider was registered (UTC time)',
    msglastmeasurements: 'Finding date last measured ...',
    lastprocessed: 'Last processed',
    status: 'Status',
    qualitycontrol: 'Quality Control',
    lastdatareg: 'Last registered data',
    qcdescription1: 'Note: It will take some time until the data for "Last registered data" has been received from the server.',
    qcdescription2: 'Orange rows indicates that the date for last registered data is at least one day later than the last processed data. This can indicate that the unit sends possible NaN values.',
    qcdescription3: 'Pink rows indicates that the date for last processed data is older than a day.',
    layerselection: 'Please select a layer from the first dropdown list and then a component. The maps are created hourly. You can add and remove layers using the checkbox list on the right side.',
    selectlayer: 'Select layer',
    selectcomponent: 'Select components',
    loadmap: 'Add map layer',
    daterangeavl: 'Date range available for',
    animatemaps: 'Animate maps',
    closeanimatemaps: 'Close maps animation',
    playanimation: 'Play animation',
    animationselection: 'Multiple maps can be animated. Click the "Animate maps" option and select a start and end date.',
    tooltipRemoveLayer: 'Remove layer from list',
    tooltipHideShowLayer: 'Hide or show the layer on map',
    tooltipDownloadImg: 'Download image',
    clearanimation: 'Clear animation map',
    animationrunning: 'Animation running....',
    datadownload: 'Download data',
    choosedates: 'Choose dates',
    starthour: 'Start hour',
    endhour: 'End hour',
    dateChooserTooltip: 'Choose start and end date by clicking two different dates in the dialog. (There are also date shortcuts in the dialog)',
    selectsensorunit: 'Select sensor unit',
    semicolon: 'semicolon ; ',
    comma: 'comma , ',
    last14days: 'Last 14 days', 
    today: 'Today',
    thisweek: 'This week',
    lastweek: 'Last week',
    thismonth: 'This month',
    lastmonth: 'Last month',
    downloadcsv: 'DOWNLOAD CSV',
    downloadcsvwithmissing: 'DOWNLOAD CSV',
    enabled: 'Enabled',
    selectsenscomp: 'Choose timeserie(s)',
    alOriginal: 'Original',
    alHour: 'Hour',
    alDay: 'Day',
    alWeek: 'Week',
    alMonth: 'Month',
    selectAggregations: 'Select aggregation level',
    showingraph: 'SHOW IN GRAPH',
    origHeader: 'ORIGINAL TIME RESOLUTION',
    origText1: 'Download data with original time resolution by selecting sensor from the drop-down list and then selecting components.',
    origText2: 'You can select semicolon or comma as separator.',
    aggHeader: 'AGGREGATED DATA',
    aggText1: 'You can plot aggregated data in a graph by selecting different time series and the aggregation level.',
    aggText2: 'In the graph there is an option for downloading the data in different formats.',
    aggGhraphTitleWait: 'Wait, data is retreved..',
    aboutDataMap: 'About data and maps',
    nodataexists: 'Unfortunately the sensor(s) and component(s) selected have no measurements for the selected time period.',
    dataloading: 'Please wait while we receive all sensors..',
    clickmarker: 'Click a marker to view status',
    online6h: 'Online more than 6 hours ago',
    online2h: 'Online more than 2 hours ago',
    online: 'Online',
    nomeasurements: 'No measurements found',
    online72h: 'Online more than 72 hours ago',
    mapinfo1: 'ABOUT MAP',
    mapinfo2: 'Mobile sensor. Location is sent with each measurement',
    mapinfo3: 'Static sensor. Location is set statically on sensor unit',
    mapinfo4: 'ABOUT COLOR CODES - Placements',
    mapinfo5: 'Last measurement not more than 2 hours ago',
    mapinfo6: 'Last measurement more than 2 hours but less than 6 hours ago',
    mapinfo7: 'Last measurement more than 6 hours but less than 42 hours ago',
    mapinfo8: 'Last measurement more than 72 hours ago',
    mapinfo9: 'ABOUT COLOR CODES - Measurements',
    pointlayers: 'POINT LAYERS',
    maplayers: 'MAP LAYERS',
    placement: 'Placement of sensors',
    measurement: 'Measurements',
    availhourinfo1: 'About layer last available hour',
    availhourinfo2: 'Because sensor data arrives to the platform at different time intervals, we retrieve hourly values from the last two hours and show the latest. Markers in gray indicates that there are no hourly values for the last two hours. ',
    csvMissingdatalbl: 'Download with missing values (only HOURLY aggregation level) : ',
    sensorstatus: 'Status sensors',
    searchplace: 'Search place',
    fanspeedinfo0: 'Fan speed 0 (based on hourly avg the last 72h)',
    fanspeedinfo1: 'Fan speed 14 000 or above (based on hourly avg the last 72h)',
    fanspeedinfo2: 'Fan speed lower than 14 000 but above 11 000 (based on hourly avg the last 72h)',
    fanspeedinfo3: 'Fan speed lower than 11 000 (based on hourly avg the last 72h)',
    fanspeedinfo: 'ABOUT COLOR CODES  - Fan speed',
    waitingforfanspeed: 'waiting for fan speed..'
  },
  'no': {
    datalevels: 'Nivåer',
    providers: 'Leverandører',
    components: 'Komponenter',
    units: 'Enhet',
    sensors: 'Sensorenheter',
    mapmenu: 'Kart - Målinger',
    sensorstatusmenu: 'Kart - Status',
    map: 'Kart',
    observations: 'Siste målinger',
    name: 'Navn',
    description: 'Beskrivelse',
    created: 'Registrert UTC',
    acronym: 'Akronym',
    from: 'Fra UTC',
    to: 'Til UTC',
    component: 'Komponent',
    components: 'Komponenter',
    value: 'Verdi',
    unit: 'Enhet',
    select: 'Velg',
    plotdata: 'Data plotting',
    plotdescription1: 'Dobbeltklikk på raden for å plotte sensordata i graf.',
    plotdescription2: 'For å plotte flere sensorer, hold Ctrl nede mens du marker sensorradene og trykk deretter på knappen for Data plotting.',
    last24h: 'Siste 24 timer',
    olddata: 'Eldste data',
    newdata: 'Nyeste data',
    viewtimeseries: 'Datointervall',
    lastmeasured: 'Dato for siste måling',
    datalevel: 'Datanivå',
    provider: 'Leverandør',
    sensorregistered: 'Sensoren ble registrert (UTC tid)',
    providerregistered: 'Leverandør ble registrert (UTC tid)',
    msglastmeasurements: 'Henter dato fro siste måling ...',
    lastprocessed: 'Dato for sist behandlet',
    status: 'Status',
    qualitycontrol: 'Kvalitetskontroll',
    lastdatareg: 'Sist registrert data',
    qcdescription1: 'NB: Det vil ta litt tid før dato for "Sist registrert data" har blitt mottatt fra serveren.',
    qcdescription2: 'Oransje rader indikerer at dato for sist registrert data er minst en dag eldre enn dato for sist behandlet. Dette kan være pga av at enheten sender bare NaN verdier.',
    qcdescription3: 'Rosa rader viser at dato for sist behandlet er over en dag gammel.',
    layerselection: 'Velg kartlag fra den første nedtrekkslisten og deretter komponent. Kartlagene blir generert for hver time. Du kan legge til og fjerne lagene ved å bruke listen på høyre side.',
    selectlayer: 'Velg et kartlag',
    selectcomponent: 'Velg komponenter',
    loadmap: 'Legg til kartlag',
    daterangeavl: 'Datoperiode tilgjengelig for',
    animatemaps: 'Animer kart',
    closeanimatemaps: 'Lukk kartanimering',
    playanimation: 'Spill av kartanimering',
    animationselection: 'Flere kart kan kjøres som en animering. Klikk på "Animer kart" og velg start- og sluttdato.',
    tooltipRemoveLayer: 'Fjern kartlag fra listen',
    tooltipHideShowLayer: 'Vis eller skjul kartlag',
    tooltipDownloadImg: 'Last ned som bilde',
    clearanimation: 'Fjern animasjonskart',
    animationrunning: 'Animasjon kjører....',
    datadownload: 'Nedlasting av data',
    choosedates: 'Velg datoer',
    starthour: 'Starttime',
    endhour: 'Sluttime',
    dateChooserTooltip: 'Velg start og sluttdato ved å klikke 2 ulike datoer i dialogen. (Man kan også bruke snarveiene på venstre side i dialogen)',
    selectsensorunit: 'Velg sensorenhet',
    semicolon: 'semikolon ; ',
    comma: 'komma , ',
    last14days: 'Siste 14 dager', 
    today: 'I dag',
    thisweek: 'Denne uken',
    lastweek: 'Sist uke',
    thismonth: 'Denne måned',
    lastmonth: 'Sist måned',
    downloadcsv: 'LAST NED CSV',
    downloadcsvwithmissing: 'LAST NED CSV',
    enabled: 'Aktivert',
    selectsenscomp: 'Velg tidsserie(r)',
    alOriginal: 'Orginal tidsoppløsning',
    alHour: 'Time',
    alDay: 'Døgn',
    alWeek: 'Uke',
    alMonth: 'Måned',
    selectAggregations: 'Velg aggregeringsnivå',
    showingraph: 'VIS I GRAF',
    origHeader: 'ORIGINAL TIDSOPPLØSNING',
    origText1: 'Last ned data med original tidsoppløsning ved å velge sensor fra nedtrekkslisten og deretter velge komponenter.',
    origText2: 'Du kan velge semikolon eller komma som separator.',
    aggHeader: 'AGGREGERTE DATA',
    aggText1: 'Her kan du vise aggregerte data i en graf ved å velge ulike tidsserier og aggregeringsnivå.',
    aggText2: 'I grafen kan du også laste ned dataene i ulike formater.',
    aggGhraphTitleWait: 'Vent, henter data..',
    aboutDataMap: 'Om data og kart',
    nodataexists: 'Sensoren(e) og komponenten(e) som er valgt har desverre ingen målinger på valgt tidsperiode',
    dataloading: 'Vennligst vent mens vi laster inn alle sensorer..',
    clickmarker: 'Klikk på en sensormarkør for å se status',
    online6h: 'Online over 6 timer siden',
    online2h: 'Online over 2 timer siden',
    online: 'Online',
    nomeasurements: 'Ingen målinger funnet',
    online72h: 'Online over 72 timer siden',
    mapinfo1: 'OM KART',
    mapinfo2: 'Mobil sensor. Lokasjonen på sensoren blir sendt sammen med hver måling',
    mapinfo3: 'Statisk sensor. Lokasjonen er satt som en fast posisjon på sensoren',
    mapinfo4: 'OM BRUK AV FARGEKODER - Plassering',
    mapinfo5: 'Siste måling ikke er mer enn 2 timer gamle',
    mapinfo6: 'Siste måling er eldre enn 2 timer men ikke mer enn 6 timer',
    mapinfo7: 'Siste måling er eldre enn 6 timer men ikke mer enn 72 timer',
    mapinfo8: 'Siste måling er eldre enn 72 timer',
    mapinfo9: 'OM BRUK AV FARGEKODER - Målinger',
    pointlayers: 'PUNKTLAG',
    maplayers: 'KARTLAG',
    placement: 'Plassering av sensorer',
    measurement: 'Målinger',
    availhourinfo1: 'Om kartlaget last available hour',
    availhourinfo2: 'Sensordata kommer inn til plattformen på ulike tidsintervaller. Vi henter derfor timesverdier fra de to siste timene og viser den nyeste av disse. I de tilfeller der vi ikke finner timesverdier for de to siste timene, er disse markert i grått.',
    csvMissingdatalbl: 'Last ned med manglende data (kun TIME verdier) : ',
    sensorstatus: 'Sensorstatus',
    searchplace: 'Søk på sted',
    fanspeedinfo0: 'Viftehastighet 0 (basert på gjennomsnittlig timeverdi de siste 72 timene)',
    fanspeedinfo1: 'Viftehastighet 14 000 eller over (basert på gjennomsnittlig timeverdi de siste 72 timene)',
    fanspeedinfo2: 'Viftehastighet lavere enn 14 000 men over 11 000 (basert på gjennomsnittlig timeverdi de siste 72 timene)',
    fanspeedinfo3: 'Viftehastighet lavere enn 11 000 (basert på gjennomsnittlig timeverdi de siste 72 timene)',
    fanspeedinfo: 'OM BRUK AV FARGEKODER - Viftehastighet',
    fanspeedinfonull: 'Viftehastighet registrert som metadata med ingen data funnet',
    waitingforfanspeed: 'venter på viftehastighet..'
  }
};

export let i18n = new VueI18n({
  locale: 'no', // set locale
  fallbackLocale: 'no', // set fallback locale
  messages, // set locale messages
});